import InputField from 'components/fields/InputField';
import React, { useEffect, useState } from 'react';
import AcademicMonthsConfig from './AcademicMonthsConfig';

const LocationDetails = ({
  schoolData,
  handleChange,
  setDisable,
  setSchoolData,
}) => {
  const [errors, setErrors] = useState([]);
  const [academicMonths, setAcademicMonths] = useState([
    { startMonth: 1, endMonth: 12, appliesTo: 'all', standards: [] },
  ]);

  useEffect(() => {
    const newErrors = [];
    if (academicMonths.length === 0) {
      newErrors.push('At least one academic month configuration is required.');
    }
    academicMonths.forEach((config, index) => {
      if (
        config.startMonth < 1 ||
        config.startMonth > 12 ||
        config.endMonth < 1 ||
        config.endMonth > 12
      ) {
        newErrors.push(`Invalid month in configuration ${index + 1}.`);
      }
      if (config.appliesTo === 'specific' && config.standards.length === 0) {
        newErrors.push(
          `Standards are required for specific configuration ${index + 1}.`
        );
      }
    });

    // Check address fields
    if (
      !schoolData.address ||
      !schoolData.city ||
      !schoolData.state ||
      !schoolData.country ||
      !schoolData.postalCode
    ) {
      newErrors.push('All address fields are required.');
    }

    setErrors(newErrors);

    // Enable/disable the next button based on errors
    setDisable(newErrors.length > 0);
  }, [schoolData, academicMonths, setDisable]);

  const updateSchoolData = (key, value) => {
    handleChange({ target: { name: key, value: value } });
  };

  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      <AcademicMonthsConfig
        academicMonths={academicMonths}
        setAcademicMonths={setAcademicMonths}
        schoolData={schoolData}
        setSchoolData={setSchoolData}
      />
      {/* Header */}
      <h4 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
        Location Details
      </h4>
      {/* content */}
      <div className="mx-auto mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
        <InputField
          extra="mb-3"
          label="Address"
          placeholder="eg. 123 Main St"
          id="address"
          type="text"
          name="address"
          maxLength={100}
          onChange={handleChange}
          value={schoolData.address}
        />
        <InputField
          extra="mb-3"
          label="City"
          placeholder="eg. New York"
          id="city"
          type="text"
          name="city"
          maxLength={50}
          onChange={handleChange}
          value={schoolData.city}
        />
        <InputField
          extra="mb-3"
          label="State"
          placeholder="eg. CA"
          id="state"
          type="text"
          name="state"
          maxLength={50}
          onChange={handleChange}
          value={schoolData.state}
        />
        <InputField
          extra="mb-3"
          label="Country"
          placeholder="eg. USA"
          id="country"
          type="text"
          name="country"
          onChange={handleChange}
          value={schoolData.country}
          maxLength={50}
        />
        <InputField
          extra="mb-3"
          label="Postal Code"
          placeholder="eg. 12345"
          id="postalCode"
          type="number"
          name="postalCode"
          onChange={handleChange}
          value={schoolData.postalCode}
          required
          maxLength={6}
        />
      </div>
      {/* Display errors */}
      {errors.length > 0 && (
        <div className="text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationDetails;
